export default {
  'resetpassword.maintext':
    'パスワードをリセットするには両方に新しいパスワードを記入してください',
  'resetpassword.retypepassword': 'もう一度記入してください',
};
